var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15869",
    "data-name": "Group 15869",
    transform: "translate(7680 -5838)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4613",
    "data-name": "Rectangle 4613",
    width: 18,
    height: 18,
    transform: "translate(-7680 5838)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clear",
    transform: "translate(-7680.01 5837.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15861",
    "data-name": "Group 15861",
    transform: "translate(1.01 1.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13828",
    "data-name": "Path 13828",
    d: "M12.173,17.011H5.847A.366.366,0,0,1,5.59,16.9L1.116,12.431a.363.363,0,0,1-.106-.257V5.847a.366.366,0,0,1,.106-.257L5.59,1.116a.366.366,0,0,1,.257-.106h6.326a.366.366,0,0,1,.257.106L16.9,5.59a.363.363,0,0,1,.106.257v6.326a.366.366,0,0,1-.106.257L12.431,16.9a.363.363,0,0,1-.257.106ZM6,16.283h6.025l4.26-4.261V6l-4.26-4.261H6L1.737,6v6.025Z",
    transform: "translate(-1.01 -1.01)",
    fill: "#e24848",
    stroke: "#e24848",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15862",
    "data-name": "Group 15862",
    transform: "translate(5.811 5.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13829",
    "data-name": "Path 13829",
    d: "M7.975,14a.363.363,0,0,1-.257-.62l5.656-5.657a.364.364,0,0,1,.514.514L8.231,13.889A.362.362,0,0,1,7.975,14Z",
    transform: "translate(-7.611 -7.612)",
    fill: "#e24848",
    stroke: "#e24848",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15863",
    "data-name": "Group 15863",
    transform: "translate(5.811 5.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13830",
    "data-name": "Path 13830",
    d: "M13.632,14a.365.365,0,0,1-.257-.106L7.718,8.231a.364.364,0,1,1,.514-.514l5.656,5.657a.364.364,0,0,1,0,.514A.36.36,0,0,1,13.632,14Z",
    transform: "translate(-7.612 -7.611)",
    fill: "#e24848",
    stroke: "#e24848",
    strokeWidth: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearChat);
export default __webpack_public_path__ + "static/media/clearChat.6963f495.svg";
export { ForwardRef as ReactComponent };